import React from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewsBlockRenderer from "../components/News/NewsBlockRenderer";
import { publicNewsApi } from "../api/newsApi";
import type { NewsArticle } from "../../types";
import { absoluteAssetUrl, formatDate, getErrorMessage } from "../utils/utils";
import "../styles/News.css";

const NewsDetailPage: React.FC = () => {
  const { slug = "" } = useParams();
  const [article, setArticle] = React.useState<NewsArticle | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    let mounted = true;
    (async () => {
      try { const data = await publicNewsApi.getBySlug(slug); if (mounted) { setArticle(data); document.title = data.seo?.seoTitle || `${data.title} | King Jades`; } }
      catch (e) { if (mounted) setError(getErrorMessage(e, "Không tìm thấy bài viết.")); }
      finally { if (mounted) setLoading(false); }
    })();
    return () => { mounted = false; };
  }, [slug]);

  return <div className="news-detail-page"><Header /><main>{loading ? <div className="news-detail-state">Đang tải bài viết...</div> : !article ? <div className="news-detail-state"><h1>Không thể mở bài viết</h1><p>{error}</p><Link to="/news">Quay lại tin tức</Link></div> : <article className="news-detail-article"><nav><Link to="/">Trang chủ</Link><span>/</span><Link to="/news">Tin tức</Link><span>/</span><b>{article.category}</b></nav><header><span>{article.category || "Tin tức"}</span><h1>{article.title}</h1>{article.subtitle ? <h2>{article.subtitle}</h2> : null}<p>{article.summary}</p><div><span>Tác giả: {article.authorName || "King Jades"}</span><span>{formatDate(article.publishedAtUtc)}</span><span>{article.viewCount} lượt xem</span></div></header>{article.coverImageUrl ? <img className="news-detail-cover" src={absoluteAssetUrl(article.coverImageUrl)} alt={article.title} /> : null}<div className="news-detail-content">{article.blocks.slice().sort((a, b) => a.order - b.order).map((block) => <NewsBlockRenderer key={block.id} block={block} />)}</div>{article.tags.length ? <footer className="news-tags"><b>Tags:</b>{article.tags.map((tag) => <span key={tag}>{tag}</span>)}</footer> : null}</article>}</main><Footer /></div>;
};

export default NewsDetailPage;
